import { environment } from "../../environments/environment";
export function setupConsoleInterceptor(): void {
    if (!environment.allowLogsInBrowser) {
        const noop = () => {};
        // Replace all console methods with no-ops in non-logging environments
        console.log = noop;
        console.debug = noop;
        console.info = noop;
        console.warn = noop;
        console.error = noop;
    }
    // else → leave console methods as-is (no suppression)
}
